import React from "react";

const Logo = ({ alt, size }) => {
  const logoSrc = window.AppInfo.logoImage;
  return logoSrc ? <img alt={alt} src={logoSrc} height={size} /> : null;
};

Logo.defaultProps = {
  alt: "Logo",
  size: 65,
};

export default Logo;
